import React, { FC, ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";

interface Props {
  icon: ReactNode;
  count?: number;
  showBadge?: boolean;
  isVisible?: boolean;
  isDimmed?: boolean;
  className?: string;
}

export const IndicatorCell: FC<Props> = ({
  icon,
  count = 0,
  showBadge = false,
  isVisible = true,
  isDimmed = false,
  className,
}) => {
  if (!isVisible) return null;

  return (
    <div
      className={cn(
        "mx-auto w-8 h-8 flex items-center justify-center bg-light-indigo rounded-lg relative",
        isDimmed && "opacity-50",
        className,
      )}
    >
      {showBadge && (
        <Badge
          variant="destructive"
          className="absolute -top-0.5 left-4 w-fit rounded-lg bg-violet flex items-center justify-center !px-1.5 !h-4 text-[12px] font-semibold"
        >
          {count}
        </Badge>
      )}
      {icon}
    </div>
  );
};
